module.exports = __webpack_public_path__ + "img/39.195e9823.jpg";